import { Trans } from '@lingui/macro'
import VaultPositionListItem from 'components/VaultPositionListItem'
import { ChadFinancePosition } from 'hooks/useChadFinancePositions'
import React from 'react'
import styled from 'styled-components/macro'
import { MEDIA_WIDTHS } from 'theme'

const DesktopHeader = styled.div`
  display: none;
  font-size: 14px;
  font-weight: 500;
  padding: 8px;

  @media screen and (min-width: ${MEDIA_WIDTHS.upToSmall}px) {
    align-items: center;
    display: flex;
    justify-content: space-between;
    & > div:last-child {
      text-align: right;
      margin-right: 12px;
    }
  }
`

const MobileHeader = styled.div`
  font-weight: medium;
  font-size: 16px;
  font-weight: 500;
  padding: 8px;
  @media screen and (min-width: ${MEDIA_WIDTHS.upToSmall}px) {
    display: none;
  }
`

type PositionListProps = React.PropsWithChildren<{
  positions: ChadFinancePosition[]
  protocol: string | undefined
}>

export default function VaultPositionList({ positions, protocol }: PositionListProps) {
  return (
    <>
      <DesktopHeader>
        <div>
          <Trans>Your Vault positions</Trans>
          {positions && ' (' + positions.length + ')'}
        </div>
      </DesktopHeader>
      <MobileHeader>
        <Trans>Your Vault positions</Trans>
      </MobileHeader>
      {positions.map((p) => {
        return <VaultPositionListItem key={p.position.tokenId.toString()} positionDetails={p} protocol={protocol} />
      })}
    </>
  )
}
